module.exports = __webpack_public_path__ + "static/media/social6.3932ab64.svg";